import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './button2.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import { Injecss } from '../../packages/injecss/injecss.js';
import Icon from '../icon/icon.js';

var bem = HoneyBem('btn', styles);
var Button = function Button(_ref) {
  var appearance = _ref.appearance,
      Elem = _ref.Elem,
      RouterLink = _ref.RouterLink,
      extraClasses = _ref.extraClasses,
      InlineIcon = _ref.InlineIcon,
      iconPosition = _ref.iconPosition,
      iconProps = _ref.iconProps,
      link = _ref.link,
      loading = _ref.loading,
      display = _ref.display,
      type = _ref.type,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["appearance", "Elem", "RouterLink", "extraClasses", "InlineIcon", "iconPosition", "iconProps", "link", "loading", "display", "type", "children"]);

  var blockClass = bem.b([appearance, display, {
    link: link,
    loading: loading,
    'has-icon': InlineIcon
  }], extraClasses); // if type button nullify type prop

  var computedtype = Elem !== 'button' ? null : type;
  var WrapperElement = RouterLink !== null ? RouterLink : Elem;
  var IconElement = InlineIcon && React.createElement(Icon, _extends({
    extraClasses: "".concat(bem.e('icon')),
    InlineIcon: InlineIcon
  }, iconProps));
  return React.createElement(WrapperElement, _extends({
    className: blockClass,
    type: computedtype
  }, rest), React.createElement(React.Fragment, null, iconPosition === 'left' && IconElement, InlineIcon && children ? React.createElement("span", {
    className: bem.e('text')
  }, children) : React.createElement(React.Fragment, null, children), iconPosition === 'right' && IconElement));
};
Button.displayName = 'Button';
Button.defaultProps = {
  appearance: null,
  display: null,
  Elem: 'button',
  RouterLink: null,
  extraClasses: '',
  InlineIcon: null,
  iconPosition: 'left',
  loading: false,
  type: 'button'
};
Button.propTypes = {
  /** Appearance  */
  appearance: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'danger']),

  /** Content of the button. required if InlineIcon is not present */

  /* eslint-disable react/require-default-props */
  // we want label to be always checked against
  children: function children(_ref2) {
    var ariaLabel = _ref2['aria-label'],
        InlineIcon = _ref2.InlineIcon,
        _children = _ref2.children;
    // if no aria label nor children or InlineIcon throw validation error
    // @todo deprecate the InlineIcon requirement,
    // it should be either children or aria label in there
    return !ariaLabel && !InlineIcon && !_children ? new Error('Either children, aria-label, or InlineIcon are required') : null;
  },

  /** Force a given display mode */
  display: PropTypes.oneOf([null, 'block', 'square']),

  /** Define wrapping element */
  Elem: PropTypes.oneOf(['button', 'a', 'span']),

  /** Wraps your Button inside a RouterLink, e.g. if you use ReactRouter or a similar library.
   * If this prop is provided the Elem prop is beeing ignored */
  RouterLink: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Optional icon needs to be an svg inline icon component */
  InlineIcon: PropTypes.func,

  /** Optional position of your InlineIcon */
  iconPosition: PropTypes.oneOf(['left', 'right']),

  /** ...rest props for icon component, use if you need passing a custom title or a color change */
  iconProps: PropTypes.object,

  /** triggers "link" appearance */
  link: PropTypes.bool,

  /** set loading state */
  loading: PropTypes.bool,

  /** Type, only available for buttons */
  type: PropTypes.oneOf(['button', 'submit', 'reset'])
};
var Button$1 = Injecss(Button, styles);

export default Button$1;
export { Button };
